import axios from './axios';
import { getToken } from './authService';
import { API_URL as API_BASE } from '../config/env';

const API_URL = `${API_BASE}/api/voucher-status`;

export const getVoucherStatuses = async (settlement_date_id) => {
  const token = getToken();
  const params = settlement_date_id ? { settlement_date_id } : {};
  const res = await axios.get(API_URL, {
    headers: { Authorization: `Bearer ${token}` },
    params,
  });
  return res.data;
};
